/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import { set_value_layer } from "../../App/actions/layerActions";
import { set_value_properties } from "../../App/actions/propertiesActions";
import { status_action } from "../../App/actions/mapActions";
import { setLanguage } from "../../App/actions/authActions";

/*PICTURE*/
import icon_edit_point from "../../Assets/svg/icon_edit_point.svg";
import icon_edit_line from "../../Assets/svg/icon_edit_line.svg";
import icon_edit_polygon from "../../Assets/svg/icon_edit_polygon.svg";
import icon_delete_geometry from "../../Assets/svg/icon_delete_geometry.svg";
import map_2d from "../../Assets/png_jpg/map_2d.png";
import map_3d from "../../Assets/png_jpg/map_3d.png";
import map_light from "../../Assets/png_jpg/map_light.png";
import map_dark from "../../Assets/png_jpg/map_dark.png";
import map_sat_square from "../../Assets/png_jpg/map_sat_square.png";
import setting from "../../Assets/svg/setting.svg";
import ICON_LEGEND from "../../Assets/jsx/ICON_LEGEND";
import ICON_GLOBE from "../../Assets/jsx/ICON_GLOBE";
import ICON_MERCATOR from "../../Assets/jsx/ICON_MERCATOR";
import ICON_SNAP from "../../Assets/jsx/ICON_SNAP";
import ICON_PAUSE from "../../Assets/jsx/ICON_PAUSE";
import ICON_SIDEBAR_CLOSE from "../../Assets/jsx/ICON_SIDEBAR_CLOSE";
import ICON_SIDEBAR_OPEN from "../../Assets/jsx/ICON_SIDEBAR_OPEN";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const type_to_draw_mode = {
  Polygon: "draw_polygon",
  Point: "draw_point",
  LineString: "draw_line_string",
};
const language_list = [
  {
    name: "INA",
    value: "ina",
    image: "https://mapid.co.id/img/icon/indo-flag.png",
  },
  {
    name: "ENG",
    value: "eng",
    image: "https://mapid.co.id/img/icon/uk-flag.png",
  },
];

const MAP_CONTROL_BASIC = ({
  auth,
  layer,
  properties,
  set_value_layer,
  set_value_properties,
  status_action,
  setLanguage,
}) => {
  const [state, setState] = useState({
    geo_location_status: "pending",
    //pending || loading || error || browser_not_supported || success
    geo_location_error: "",
    modal_setting: false,
    modal_setting_map: false,
    anchor: null,
  });

  //local state
  const { modal_setting, anchor } = state;

  //global props
  const { map_object, geometryStatus, draw_active, geo_layer_list, layer_id } =
    layer;

  const geo_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id
  )?.geo_layer;
  const current_type = geo_layer?.type;

  const {
    projection,
    basemap_used,
    sidebar_right_status,
    legend_status,
    is_snap_draw_active,
    is_pause_fly_to,
  } = properties;

  //local storage
  const language = localStorage?.language || auth.language;

  useEffect(() => {
    const geometryStatus_after = layer.geometryStatus;
    const right_sidebar_toggle = document.getElementById(
      "right_sidebar_toggle"
    );
    const setting_map = document.getElementById("setting_map");
    if (geometryStatus_after) {
      right_sidebar_toggle.style.top = "205px";
      setting_map.style.top = "241px";
    } else {
      right_sidebar_toggle.style.top = "135px";
      setting_map.style.top = "171px";
    }
  }, [layer.geometryStatus]);

  const on_open_setting = (event) => {
    setState((prevState) => ({
      ...prevState,
      modal_setting: !state.modal_setting,
      anchor: event?.currentTarget,
    }));
  };

  const on_close_setting = () => {
    setState((prevState) => ({
      ...prevState,
      modal_setting: false,
    }));
  };

  const on_set_lang = (language) => {
    setLanguage(language);
  };

  const on_set_style_map = (basemap_used) => {
    const basemap_url = process.env.REACT_APP_MAPID_BASEMAP;
    const basemap_key = process.env.REACT_APP_BASEMAP_KEY;
    let style_url = "";
    switch (basemap_used) {
      case "2d":
        style_url = `${basemap_url}/styles/street-2d-building/style.json?key=${basemap_key}`;
        break;
      case "3d":
        style_url = `${basemap_url}/styles/basic/style.json?key=${basemap_key}`;
        break;
      case "light":
        style_url = `${basemap_url}/styles/light/style.json?key=${basemap_key}`;
        break;
      case "dark":
        style_url = `${basemap_url}/styles/dark/style.json?key=${basemap_key}`;
        break;
      case "sat":
        style_url = `${basemap_url}/styles/satellite/style.json?key=${basemap_key}`;
        break;
      default:
        style_url = `${basemap_url}/styles/street-2d-building/style.json?key=${basemap_key}`;
        break;
    }
    if (map_object) {
      //part 1
      set_value_properties({
        key: "basemap_used",
        value: basemap_used,
      });
      // Set the style first
      map_object.setStyle(style_url);
      // Wait for the style to load before setting projection
      map_object.once("style.load", () => {
        map_object.setProjection({ type: projection });
      });

      //part 2 - triggers 1 second after part 1
      setTimeout(() => {
        status_action();
      }, 1000); // 1000 milliseconds = 1 second
    }
  };

  const toggle_sidebar_right = () => {
    on_close_setting();
    const { sidebar_right_status } = properties;
    set_value_properties({
      key: "sidebar_right_status",
      value: !sidebar_right_status,
    });
  };

  const toggle_legend = () => {
    set_value_properties({
      key: "legend_status",
      value: !properties.legend_status,
    });
  };

  const on_create_geometry = () => {
    const { map_object, geo_layer_list, layer_id } = layer;

    const geo_layer = geo_layer_list.find(
      (item) => item?.geo_layer?._id === layer_id
    )?.geo_layer;
    const current_type = geo_layer?.type;

    const draw_object = layer.draw_object;
    const draw_mode = type_to_draw_mode?.[current_type] || "";
    if (map_object && draw_mode) {
      map_object.getCanvas().style.cursor = "crosshair";
      if (draw_object) {
        draw_object.changeMode(draw_mode);
      }
      set_value_layer({
        key: "draw_active",
        value: true,
      });
    }
  };

  const on_delete_geometry = () => {
    const { map_object } = layer;
    const draw_object = layer.draw_object;
    let feature_selected;
    let feature_id;
    if (draw_object) {
      feature_selected = draw_object.getSelected()?.features?.[0];
      feature_id = feature_selected?.id;
    }
    if (feature_id && map_object) {
      if (draw_object) {
        draw_object.trash(feature_id);
      }
    }
  };

  const on_change_projection = (projection) => {
    set_value_properties({
      key: "projection",
      value: projection,
    });
    const { map_object } = layer;
    if (map_object) {
      map_object.setProjection({
        type: projection, //mercator || globe
      });
    }
    status_action();
  };

  const toggle_snap_draw_active = () => {
    set_value_properties({
      key: "is_snap_draw_active",
      value: !properties.is_snap_draw_active,
    });
  };

  const toggle_pause_fly_to = () => {
    set_value_properties({
      key: "is_pause_fly_to",
      value: !properties.is_pause_fly_to,
    });
  };

  const modal_setting_content = (
    <FLOAT_MENU
      anchorEl={anchor}
      open={modal_setting}
      onClose={on_close_setting}
    >
      <div style={{ width: "235px" }} className="noselect">
        <h1 className="text_bold margin_top">Map Control Center</h1>
        <br />

        <section className="container background_grey_light margin_bottom container_base_map_style">
          <div className="text_choose text_medium">Style Basemap</div>
          <div className="base_1">
            <img
              className="cursor_pointer"
              onClick={() => on_set_style_map("2d")}
              data-mapid="clickBaseMap"
              alt="base_1"
              src={map_2d}
              style={{
                height: "37px",
                verticalAlign: "middle",
                borderRadius: "7px",
                border: `5px solid ${
                  basemap_used === "2d" ? "#000" : "#dedede"
                }`,
              }}
            />
          </div>
          <div className="base_2">
            <img
              className="cursor_pointer"
              onClick={() => on_set_style_map("3d")}
              data-mapid="click3dMap"
              alt="base_2"
              src={map_3d}
              style={{
                height: "37px",
                verticalAlign: "middle",
                borderRadius: "7px",
                border: `5px solid ${
                  basemap_used === "3d" ? "#000" : "#dedede"
                }`,
              }}
            />
          </div>
          <div className="base_3">
            <img
              className="cursor_pointer"
              onClick={() => on_set_style_map("light")}
              data-mapid="clickLightMap"
              alt="base_3"
              src={map_light}
              style={{
                height: "37px",
                verticalAlign: "middle",
                borderRadius: "7px",
                border: `5px solid ${
                  basemap_used === "light" ? "#000" : "#dedede"
                }`,
              }}
            />
          </div>
          <div className="base_4">
            <img
              className="cursor_pointer"
              onClick={() => on_set_style_map("dark")}
              data-mapid="clickDarkMap"
              alt="base_4"
              src={map_dark}
              style={{
                height: "37px",
                verticalAlign: "middle",
                borderRadius: "7px",
                border: `5px solid ${
                  basemap_used === "dark" ? "#000" : "#dedede"
                }`,
              }}
            />
          </div>
          <div className="base_5">
            <img
              className="cursor_pointer"
              onClick={() => on_set_style_map("sat")}
              data-mapid="clickSateliteMap"
              alt="base_5"
              src={map_sat_square}
              style={{
                height: "37px",
                verticalAlign: "middle",
                borderRadius: "7px",
                border: `5px solid ${
                  basemap_used === "sat" ? "#000" : "#dedede"
                }`,
              }}
            />
          </div>
        </section>

        <section className="two_container_equal margin_bottom">
          <div className="container background_grey_light">
            <p className="text_medium  margin_bottom">
              {dict?.["Map Projection"]?.[language]}
            </p>
            <div className="two_container_equal">
              <div
                className="cursor_pointer"
                onClick={() => on_change_projection("mercator")}
                style={{
                  height: "36px",
                  width: "36px",
                  borderRadius: "18px",
                  backgroundColor: projection === "mercator" ? "#000" : "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ICON_MERCATOR
                  style={{ height: "20px" }}
                  color={projection === "mercator" ? "#fff" : "#000"}
                />
              </div>

              <div
                className="cursor_pointer"
                onClick={() => on_change_projection("globe")}
                style={{
                  height: "36px",
                  width: "36px",
                  borderRadius: "18px",
                  backgroundColor: projection === "globe" ? "#000" : "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ICON_GLOBE
                  style={{ height: "20px" }}
                  color={projection === "globe" ? "#fff" : "#000"}
                />
              </div>
            </div>
          </div>

          <div className="container background_grey_light">
            <p className="text_medium  margin_bottom">
              {dict?.["Language"]?.[language]}
            </p>
            <div className="two_container_equal">
              {language_list.map((item, idx) => {
                return (
                  <div
                    key={idx}
                    className="cursor_pointer"
                    onClick={() => on_set_lang(item.value)}
                    data-mapid={`clickChangeLanguage-${item.value}`}
                    style={{
                      height: "36px",
                      width: "36px",
                      borderRadius: "18px",
                      backgroundColor:
                        language === item.value ? "#000" : "#fff",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      key={idx}
                      className="cursor_pointer"
                      style={{
                        height: "15px",
                      }}
                      alt={item.name}
                      src={item.image}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section className="two_container_equal margin_bottom">
          <div
            className="container background_grey_light two_container_auto control_center cursor_pointer"
            style={{ height: "60px" }}
            onClick={toggle_snap_draw_active}
          >
            <div
              className="cursor_pointer"
              style={{
                height: "36px",
                width: "36px",
                borderRadius: "18px",
                backgroundColor: is_snap_draw_active ? "#000" : "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ICON_SNAP
                style={{ height: "20px" }}
                color={is_snap_draw_active ? "#fff" : "#000"}
              />
            </div>
            <p className="text_medium" style={{ width: "calc(100% - 45px)" }}>
              Snap Draw
            </p>
          </div>
          <div
            className="container background_grey_light two_container_auto control_center cursor_pointer"
            style={{ height: "60px" }}
            onClick={toggle_pause_fly_to}
          >
            <div
              className="cursor_pointer"
              style={{
                height: "36px",
                width: "36px",
                borderRadius: "18px",
                backgroundColor: is_pause_fly_to ? "#000" : "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ICON_PAUSE
                style={{ height: "25px" }}
                color={is_pause_fly_to ? "#fff" : "#000"}
              />
            </div>
            <p className="text_medium" style={{ width: "calc(100% - 45px)" }}>
              Pause Fly To
            </p>
          </div>
        </section>

        <div
          className="container background_grey_light two_container_auto control_center cursor_pointer"
          style={{ height: "60px", width: "50%" }}
          onClick={toggle_legend}
        >
          <div
            style={{
              height: "36px",
              width: "36px",
              borderRadius: "18px",
              backgroundColor: legend_status ? "#000" : "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ICON_LEGEND
              style={{ height: "15px" }}
              color={legend_status ? "#fff" : "#000"}
            />
          </div>
          <p className="text_medium">Legenda</p>
        </div>
      </div>
    </FLOAT_MENU>
  );

  return (
    <main>
      {modal_setting_content}
      {geometryStatus && (
        <>
          <button
            className={`map_button_control create_geometry ${
              draw_active ? "control_active" : ""
            }`}
            onClick={on_create_geometry}
            data-mapid="clickDigitasi"
          >
            {current_type === "Point" ? (
              <img alt="A" src={icon_edit_point} height={15} />
            ) : current_type === "LineString" ? (
              <img alt="A" src={icon_edit_line} height={15} />
            ) : current_type === "Polygon" ? (
              <img alt="A" src={icon_edit_polygon} height={15} />
            ) : (
              "?"
            )}
          </button>
          <button
            className="map_button_control delete_geometry"
            onClick={on_delete_geometry}
          >
            <img alt="Del" src={icon_delete_geometry} width={15} />
          </button>
        </>
      )}
      {sidebar_right_status ? (
        <button
          className="map_button_control right_sidebar_toggle"
          id="right_sidebar_toggle"
          onClick={toggle_sidebar_right}
        >
          <ICON_SIDEBAR_CLOSE
            color="#000"
            style={{
              width: "17px",
            }}
          />
        </button>
      ) : (
        <button
          className="map_button_control right_sidebar_toggle"
          id="right_sidebar_toggle"
          onClick={toggle_sidebar_right}
        >
          <ICON_SIDEBAR_OPEN
            color="#000"
            style={{
              width: "17px",
            }}
          />
        </button>
      )}

      <button
        className="map_button_control setting_map"
        id="setting_map"
        onClick={on_open_setting}
        data-mapid="clickTool"
      >
        <img
          src={setting}
          height={19}
          alt="sat"
          style={{
            borderRadius: "7px",
          }}
        />
      </button>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  set_value_layer,
  set_value_properties,
  status_action,
  setLanguage,
})(MAP_CONTROL_BASIC);
